module.exports = __webpack_public_path__ + "img/dump_driving.8894931f.svg";